import React, { useContext } from 'react';
import ReactDOM from 'react-dom';

//component
import UserGroupsWorkspacesTab from  '@/components/page/OrgSettings/UserGroups/UserGroupsWorkspaces';

//context
import { OrgSettingsUserGroupsContext } from '@/context/OrgSettingsUserGroupsContext';



const UserGroupsWorkspacesTabPortal = () => {    
    const { setUserGroupId, setUserGroupName } = useContext(OrgSettingsUserGroupsContext);

    const targetContainer = document.getElementById('react-group-workspace-tab-container');
    if (!targetContainer) {
        return null;
    } else {
        setUserGroupId(targetContainer.getAttribute('data-user-group-id'))
        setUserGroupName(targetContainer.getAttribute('data-user-group-name'))
    }

    return ReactDOM.createPortal(
      <UserGroupsWorkspacesTab />, targetContainer
    );
}


export default UserGroupsWorkspacesTabPortal;